import styled from 'styled-components';
import bgModal from '../../../assets/images/bg_modal_conlicitaseg.png';

export const Container = styled.div`
  background-image: url(${bgModal});
  background-size: cover;
  padding: 60px 40px;
  text-align: center;

  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    z-index: 2;
    transition: opacity 0.2s;
  }

  .modal-content-wrapper {
    max-width: 80%;
    margin: 0 auto;
  }

  .celebration-icon {
    font-size: 2rem;
    margin: 5px;
  }

  .title {
    font-size: 2rem;
    font-weight: 700;
    margin: 5px;
  }

  .edital-card {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 24px;
    text-align: left;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: 768px) {
    padding: 45px 5px;

    .celebration-icon {
      font-size: 2rem;
      margin: 5px;
    }

    .title {
      font-size: 1.5rem;
      margin: 5px;
    }

    .edital-card {
      padding: 16px 20px;
      flex-direction: column;
      display: flex;
      align-items: flex-start;
    }

    .edital-action .btn-start {
      width: 100%;
    }
  }
`;
